<template>
  <v-container class="pa-10">
    <v-tabs
      show-arrows
      dark
      background-color="primary"
      v-model="tab"
      height="100px"
      icons-and-text
      fixed-tabs
      centered
    >
      <v-tab v-for="tab in tabs" :key="tab">
        {{ tab }}
        <image-view
          width="50px"
          class="mb-2"
          height="50px"
          :src="getImage(tab)"
        ></image-view>
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item> <prepaid /> </v-tab-item>
      <v-tab-item> <postpaid></postpaid> </v-tab-item>
      <v-tab-item> <STV></STV> </v-tab-item>
      <v-tab-item> <DTH></DTH> </v-tab-item>
      <v-tab-item> <broad-band></broad-band> </v-tab-item>
      <v-tab-item> <electricity></electricity> </v-tab-item>
      <v-tab-item> <gas></gas> </v-tab-item>
      <v-tab-item> <water></water> </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import ImageView from "../components/ImageView.vue";
import BroadBand from "../components/recharge/BroadBand.vue";
import DTH from "../components/recharge/DTH.vue";
import Electricity from "../components/recharge/Electricity.vue";
import Gas from "../components/recharge/Gas.vue";
import Postpaid from "../components/recharge/Postpaid.vue";
import Prepaid from "../components/recharge/Prepaid.vue";
import STV from "../components/recharge/STV.vue";
import Water from "../components/recharge/Water.vue";
export default {
  components: {
    Prepaid,
    Postpaid,
    BroadBand,
    STV,
    DTH,
    Gas,
    Water,
    Electricity,
    ImageView,
  },
  data() {
    return {
      tab: 0,
      tabs: [
        "Prepaid",
        "Postpaid",
        "STV",
        "DTH",
        "Broadband",
        "Electricity",
        "Gas",
        "Water",
      ],
    };
  },
  methods: {
    getImage(tab) {
      tab = tab.toLowerCase();
      return require(`../assets/images/${tab}.svg`);
    },
    init() {
      const vm = this;
      let { way } = vm.$route.query;
      if (way) {
        vm.tab = vm.tabs.indexOf(way);
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style>
</style>